<div
  *ngIf="loading"
  class="fixed top-0 left-0 w-screen h-screen flex items-center justify-center z-10"
>
  <div class="bg-gray-100 opacity-50 h-screen w-screen absolute"></div>
  <mat-spinner></mat-spinner>
</div>
<section *ngIf="isDateInRange">
  <div class="md:flex">
    <div>
      <a href="./choose-product?disc=CYBERFIL50"
        ><img
          src="./assets/cyberfil/banner_50.png"
          alt="Descuento 50%"
          class="sm:opacity-100 opacity-75 transition-all duration-300 hover:opacity-100 hover:drop-shadow-sm"
      /></a>
    </div>
    <div>
      <a href="./choose-product?disc=CYBERFIL20"
        ><img
          src="./assets/cyberfil/banner_20.png"
          alt="Descuento 20% x 3 meses"
          class="sm:opacity-100 opacity-75 transition-all duration-300 hover:opacity-100 hover:drop-shadow-sm"
      /></a>
    </div>
  </div>
</section>
<section class="relative pb-20 mt-0 mb-0">
  <!-- <h1 class="font-bold text-5xl text-primary text-center mb-10">Elegí tu plan.</h1> -->
  <h2
    *ngIf="zip_code && viewProducts && viewProducts.length > 0"
    class="font-bold text-3xl text-green-500 text-center"
  >
    ¡Felicidades!
  </h2>
  <h3
    *ngIf="zip_code && viewProducts && viewProducts.length > 0"
    class="text-2xl text-primary font-bold text-center"
  >
    De acuerdo a tu código postal {{ zip_code }}, tenemos cobertura y te
    recomendamos los siguientes planes:
  </h3>
  <h3
    *ngIf="zip_code && viewProducts && viewProducts.length > 0"
    class="text-2xl text-primary font-bold text-center"
  >
    ¿Deseas cambiar tu código postal?
  </h3>
  <!--<div class="font-bold text-3xl text-primary text-center bg-gray-100 pt-10 pb-5">Productos</div>-->
  <h3
    *ngIf="
      (zip_code && !viewProducts && !loading) ||
      (zip_code && viewProducts.length == 0 && !loading)
    "
    class="text-2xl text-primary font-bold text-center"
  >
    <p>¡Malas noticias!</p>
    <p>Por el momento no tenemos productos para ofrecerte</p>
  </h3>

  <!--<div
    *ngIf="!loading"
    class="font-bold text-2xl md:text-3xl text-primary text-center bg-gray-200 pt-10 pb-5"
  >
    Dispensers
  </div>-->

  <!-- inicio de productos-->
   <div *ngIf="!loading" class="relative z-0">
    <div class="z-0 absolute top-0 w-full" style="background-color: #ECECEC; height: 300px;"></div>
    <div class="items-center justify-center relative text-center">
      <h1 class="p-5 text-2xl text-primary">Tienda</h1>
      <h3 class="text-lg text-gray-600"></h3>
    </div>
   </div>

  <div class="flex items-center justify-center mx-0 md:mt-3 z-30 relative">
    <div class="md:flex flex-wrap px-0 md:px-10 gap-10 justify-center">
      <div
        *ngFor="let product of productsForSale"
        class="cursor-pointer mb-4 md:mb-0 flex flex-col group max-w-md bg-white hover:bg-gray-100 hover:shadow-2xl shadow-xl rounded-lg p-5 text-center transition duration-300 ease-in-out z-30 "
        (click)="product?.out_of_stock !== 1 && productDetail(product, 'sale')"
        [routerLink]="product?.out_of_stock !== 1 ? '/product/' + product.id : null"
        [queryParams]="{ product: product.id }">
        <div
          class="text-center flex-shrink-0 flex justify-center items-center relative z-30"
          
        >
          <img
            class="group-hover:scale-110 mx-auto group-hover:-translate-y-9 transform transition duration-300 ease-in-out"
            style="height: 190px"
            [src]="product?.galeries[0]?.file_name"
            alt="Imagen del producto"
          />
        </div>

        <hr class="my-4 bg-black max-h-px" />

        <div class="text-primary font-bold text-2xl h-8 pt-5 mb-5">
          {{ product.name }}
        </div>

        <div
          *ngIf="product?.short_description"
          [innerHTML]="product?.short_description"
          class="text-sm text-gray-500 mb-1"
        ></div>

        <div class="mt-auto">
          <div class="font-normal text-sm">
            <span
              style="text-decoration-line: line-through"
              class="text-primary text-lg font-semibold"
            >
              ${{ formatNumber(product?.tachado) }}
            </span>
            <div class="relative flex items-center justify-center">
              <div
                class="bg-primary font-bold text-center py-2 px-8 rounded-xl text-white w-full"
              >
                <div class="absolute" style="top: -10px; right: -10px">
                  <div
                    class="rounded-full text-sm font-semibold bg-secondary text-white p-2 w-10 h-10 flex items-center justify-center"
                    style="z-index: 10"
                  >
                    {{ getSalePrice(product, 0)?.percentage }}%
                  </div>
                </div>
                <span class="text-xl">
                  ${{ formatNumber(getSalePrice(product, 0)?.price) }}
                </span>
                <br />
                <span class="font-light text-xs">
                  {{ getPrice(product).periodicity_label }}
                </span>
              </div>
            </div>

            <!-- <p class="mt-2">
              <span class="text-xs">
                <span
                  *ngIf="getPrice(product)?.cost == 0"
                  class="block text-green-500"
                >
                  Instalación Gratis
                </span>
              </span>
            </p> -->
          </div>
          <p class="font-semibold text-primary">Envío incluído</p>
          <p class="font-normal text-primary text-xs">Llega en CABA y GBA: 1 día hábil</p>
          <span class="font-normal text-gray-500 leading-none" style="font-size: 10px;"
          >Precio sin impuestos nacionales:
          ${{
            formatNumber(landingService.priceWithoutIva(product))
          }}
        </span>
          
        </div>
      </div>
    </div>
  </div>
</section>
<app-whyus></app-whyus>
<app-our-filters></app-our-filters>
<app-certificated-filter></app-certificated-filter>
<!-- <app-zip-code-form></app-zip-code-form>
<app-landing-faqs></app-landing-faqs> -->
